<template>
  <h-anchor class="anchor" :idList="idList">
    <el-form
      ref="formRef"
      label-width="100px"
      class="demo-dynamic"
      :model="formData"
      :disabled="isDisabled"
      :rules="rules"
    >
      <div id="one">
        <div class="formTitle"><span></span>基本信息</div>
        <el-form-item label="街道名称" prop="jdmc">
          <el-select
            style="width: 100%"
            @change="jdChange"
            v-model="formData.jdmc"
            placeholder="请选择街道名称"
          >
            <el-option
              v-for="item in regionselectList"
              :key="item.name"
              :label="item.name"
              :value="item.regionId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="社区名称" prop="sqmc">
          <el-select
            style="width: 100%"
            @change="sqChange"
            v-model="formData.sqmc"
            placeholder="请选择社区名称"
          >
            <el-option
              v-for="item in sqList"
              :key="item.name"
              :label="item.name"
              :value="item.regionId"
            >
            </el-option>
          </el-select>
          <!-- <el-input disabled v-model="formData.parent"></el-input> -->
        </el-form-item>
        <el-form-item label="网格名称" prop="parentId">
          <el-select
            style="width: 100%"
            v-model="formData.parentId"
            placeholder="请选择网格名称"
          >
            <el-option
              v-for="item in wgList"
              :key="item.name"
              :label="item.name"
              :value="item.regionId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区名称" prop="name">
          <el-input
            v-model="formData.name"
            placeholder="请输入小区名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="小区地址" prop="address">
          <el-input
            v-model="formData.address"
            placeholder="请输入小区地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="物业联系人">
          <el-input
            v-model="formData.contactName"
            placeholder="请输入物业联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="物业联系方式">
          <el-input
            v-model="formData.contactPhone"
            placeholder="请输入物业联系方式"
          ></el-input>
        </el-form-item>
      </div>
      <div id="two">
        <div class="formTitle"><span></span>地理信息</div>
        <el-form-item label="车位数">
          <el-input
            v-model.number="formData.parkNum"
            type="number"
            placeholder="车位数"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度" prop="longitude">
          <el-input
            v-model="formData.longitude"
            placeholder="请输入经度"
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度" prop="latitude">
          <el-input
            v-model="formData.latitude"
            placeholder="请输入纬度"
          ></el-input>
        </el-form-item>
        <el-form-item label="面积" prop="unitArea">
          <el-input
            v-model="formData.unitArea"
            placeholder="请输入面积"
          ></el-input>
        </el-form-item>
      </div>
      <div id="three" style="height: 550px">
        <div class="formTitle"><span></span>其他</div>
        <el-form-item label="负责人" prop="principal">
          <el-input
            v-model="formData.principal"
            placeholder="请输入负责人"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="formData.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
  </h-anchor>
  <div style="text-align: center; margin-top: 12px" v-if="!isDisabled">
    <h-button type="primary" @click="submitForm()">提交</h-button>
    <h-button @click="closeDialog">取消</h-button>
    <h-button @click="getCoordinates">获取坐标</h-button>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  watchEffect,
  ref,
} from "vue";
import { queryDeptList } from "@/api/system";
import { ElMessage } from "element-plus";
import { addRegions, updateRegions } from "@/api/system/region";
import { regionselect, regioninfoinfo } from "@/api/realHouse/realHouse.js";

import util from "@util/js";
import _ from "lodash";

export default defineComponent({
  name: "StreetForm",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
      emitPath: false,
    },
    type: {
      type: Number,
      default: 1, // 1:添加；2:编辑；3:只读
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["drawArea", "getCoordinates", "update:modelValue", "submit"],
  setup(props, { emit }) {
    const state = reactive({
      regionselectList: [],
      sqList: [],
      wgList: [],
      topTitle: "添加/编辑",
      lableTitle: "名称",
      parent: "",
      dialogVisible: false,
      isDisabled: false,
      coordinate: "",
      props: {
        multiple: true,
        checkStrictly: true,
        label: "name",
        value: "deptId",
      },
      deptTree: [],
      formData: {
        jdmc: "",
        sqmc: "",
        unitArea: "",
        principal: "",
        // apiType: 'street',
        parentId: "",
        coord: "", // 坐标
        name: "",
        longitude: "", // 经度
        latitude: "", // 纬度
        type: "", // props.params.type
        contactName: "", // 联系人
        contactPhone: "", // 联系方式
        parkNum: "", // 车位数
        address: "", // 地址
        startFloor: "", // 起始楼层
        endFloor: "", // 结束楼层
        remark: "", // 备注,
        roomNum: "", // 房间数
      },
      formBack: {},
      rules: {
        jdmc: [
          {
            required: true,
            message: "请选择街道名称",
            trigger: "change",
          },
        ],
        sqmc: [
          {
            required: true,
            message: "请选择社区名称",
            trigger: "change",
          },
        ],
        parentId: [
          {
            required: true,
            message: "请选择网格名称",
            trigger: "change",
          },
        ],

        name: [
          {
            required: true,
            message: "请输入街道名称",
            trigger: "blur",
          },
        ],
        // address: [
        //   {
        //     required: true,
        //     message: "请输入小区地址",
        //     // trigger: 'blur'
        //   },
        // ],
        longitude: [
          {
            required: true,
            message: "请输入经度",
            trigger: "blur",
          },
        ],
        latitude: [
          {
            required: true,
            message: "请输入纬度",
            trigger: "blur",
          },
        ],
      },
      idList: [
        { name: "基本信息", id: "one", icon: "icon-shenfenzheng" },
        { name: "地理信息", id: "two", icon: "icon-invite" },
        { name: "其他信息", id: "three", icon: "icon-shuidianbiaoguanli" },
      ],
    });
    state.formBack = _.cloneDeep(state.formData);
    const refData = toRefs(state);
    const formRef = ref(null);

    // 重置表单
    const resetForm = () => {
      if (!formRef.value) return;
      formRef.value.resetFields();
    };

    // 监听区域树选中变化
    watch(
      [() => props.params, () => props.type],
      (v) => {
        resetForm(formRef.value);
        console.log(props.type, 9999999999);
        state.isDisabled = false;
        switch (props.type) {
          case 1: // 添加
            state.formData = _.cloneDeep(state.formBack);
            break;
          case 2: // 修改
            state.formData = _.cloneDeep(props.params);
            break;
          case 3: // 只读
            state.isDisabled = true;
            break;
        }
      },
      { immutable: true }
    );
    watchEffect(() => {
      switch (props.type) {
        case 1: // 添加
          state.formData = _.cloneDeep(state.formBack);
          break;
        case 2: // 修改
          state.formData = _.cloneDeep(props.params);
          break;
        case 3: // 只读
          state.isDisabled = true;
          break;
      }
    });
    // 监听弹框显示
    watch(
      () => props.modelValue,
      (v) => {
        state.dialogVisible = v;
        if (props.params.levelName) {
          state.parent =
            props.params.levelName.split("/")[
              props.params.levelName.split("/").length - 2
            ];
        } else {
          state.parent = props.params.name;
        }
      },
      { immutable: true }
    );
    watch(
      () => state.dialogVisible,
      (v) => {
        emit("update:modelValue", v);
      }
    );
    const closeDialog = () => {
      emit("update:modelValue", false);
    };
    const regioninfoinfoAxios = async (regionId) => {
      state.formData = { ...props.params };
      const res = await regioninfoinfo(regionId);
      state.wgList = [res.regionInfo];
      state.formData.parentId = res.regionInfo.regionId;
      const ress = await regioninfoinfo(res.regionInfo.parentId);
      state.sqList = [ress.regionInfo];
      state.formData.sqmc = ress.regionInfo.regionId;
      const resss = await regioninfoinfo(ress.regionInfo.parentId);
      state.regionselectList = [resss.regionInfo];
      state.formData.jdmc = resss.regionInfo.regionId;
    };
    watchEffect(() => {
      if (props.type === 2 || props.type === 3) {
        console.log(props.params);
        regioninfoinfoAxios(props.params.parentId);
      }
    });
    watch(
      () => props.params,
      (v) => {
        if (v.type) {
          state.topTitle = "添加/编辑" + props.params.name;
          // lableTitle
        }
        if (v.type === "root") {
          state.lableTitle = "街道名称";
        } else if (v.type === "0") {
          state.lableTitle = "社区名称";
        } else if (v.type === "1") {
          state.lableTitle = "网格名称";
        } else if (v.type === "2") {
          state.lableTitle = "小区名称";
        } else if (v.type === "3") {
          state.lableTitle = "楼栋名称";
        } else if (v.type === "4") {
          state.lableTitle = "单元名称";
        } else if (v.type === "5") {
          state.lableTitle = "单元名称";
        }
      }
    );
    // 获取坐标按钮
    const getCoordinates = () => {
      emit("getCoordinates");
    };
    // 绘制区域按钮
    const drawAreaBtn = () => {
      emit("drawArea");
    };
    // 获取部门列表
    const queryOrganListAsync = async () => {
      const res = await queryDeptList();
      const options = { pid: "parentId", id: "deptId", rootPid: res.top };
      const treeData = util.arrayToTree(res.deptList, options);
      if (treeData[0] && treeData[0].deptId === 0) {
        treeData[0].disabled = true;
      }
      state.deptTree = treeData;
      // props.tabsVal
    };
    queryOrganListAsync();
    // 获取街道社区网格
    const regionselectAxios = async () => {
      const params = {
        type: "0",
      };
      const res = await regionselect(params);
      state.regionselectList = res.data;
    };
    regionselectAxios();
    const jdChange = async (val) => {
      console.log(val, 555);
      const data = {
        parentId: val,
        type: "1",
      };
      const ress = await regionselect(data);
      state.sqList = ress.data;
    };
    const sqChange = async (val) => {
      const data = {
        parentId: val,
        type: "2",
      };
      const ress = await regionselect(data);
      state.wgList = ress.data;
    };

    // 提交数据
    const submitForm = async () => {
      formRef.value.validate(async (valid) => {
        if (!valid) return;
        state.formData.type = props.tabsVal; // props.params.type;tabsVal
        // state.formData.parentId = props.params.id;
        const form = _.cloneDeep(state.formData);
        util.formatForm(form);
        //下面暂时不知道干嘛用。先注释掉
        // if (form.coord !== "[]" && form.coord) {
        //   form.coord = form.coord.join(";");
        // }
        form.type = 3;
        delete form.jdmc;
        delete form.sqmc;
        let res;
        if (props.type === 1) {
          res = await addRegions(form);
        } else if (props.type === 2) {
          res = await updateRegions(form);
        }
        if (res.code === 0) {
          ElMessage.success(props.type === 1 ? "添加成功" : "修改成功");
          resetForm(formRef.value);
          state.dialogVisible = false;
          emit("submit");
        }
      });
    };
    // 设置经纬度
    const setPoint = (point) => {
      const [longitude, latitude] = point;
      Object.assign(state.formData, { longitude, latitude });
    };
    // 设置区域坐标
    const setPointPath = (path) => {
      console.log(
        "%c [ path ]-211",
        "font-size:13px; background:pink; color:#bf2c9f;",
        path
      );
      state.formData.coord = path;
    };

    return {
      ...refData,
      formRef,
      getCoordinates,
      drawAreaBtn,
      submitForm,
      setPoint,
      setPointPath,
      jdChange,
      sqChange,
      closeDialog,
    };
  },
});
</script>
<style lang="scss" scoped>
.anchor {
  max-height: 550px;
  .formTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    span {
      width: 3.5px;
      height: 16px;
      background-color: #5584ff;
      margin-right: 10px;
    }
  }
}
</style>
